import { ReactNode } from 'react';

interface SidebarLinkGroupProps {
  children: (handleClick: () => void, open: boolean) => ReactNode;
  activeCondition: boolean;
  groupKey: string;
  openDropdown: string | null;
  setOpenDropdown: (key: string | null) => void;
}

const SidebarLinkGroup = ({
  children,
  activeCondition,
  groupKey,
  openDropdown,
  setOpenDropdown,
}: SidebarLinkGroupProps) => {
  const open = openDropdown === groupKey;

  const handleClick = () => {
    if (open) {
      setOpenDropdown(null); // close if already open
    } else {
      setOpenDropdown(groupKey); // open this and close others
    }
  };

  return <li>{children(handleClick, open)}</li>;
};

export default SidebarLinkGroup;
